"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountMenu = void 0;
var _react = _interopRequireDefault(require("react"));
var _CardBox = require("b2b-components/theme/components/CardBox");
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
var _Group = require("./Group");
require("./AccountMenu.scss");
const AccountMenu = _ref => {
  let {
    title,
    groups,
    onLinkClick,
    border = false,
    className
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-AccountMenu', {
    'cds-AccountMenu--Bordered': border
  }, className);
  const renderContent = () => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement("h3", {
    className: "cds-AccountMenu-Title"
  }, title), Array.isArray(groups) && groups.map((group, index) => /*#__PURE__*/_react.default.createElement(_Group.Group, {
    title: group.title,
    items: group.items,
    onLinkClick: onLinkClick,
    key: (0, _key.createKey)(index, 'group')
  })));
  if (border) {
    return /*#__PURE__*/_react.default.createElement(_CardBox.CardBox, {
      className: rootClassName,
      titleSize: _CardBox.CARD_BOX_TITLE_SIZE.default
    }, renderContent());
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, renderContent());
};
exports.AccountMenu = AccountMenu;
//# sourceMappingURL=AccountMenu.js.map